module.exports = __webpack_public_path__ + "img/logo.710913c5.svg";